export default "__VITE_ASSET__DGbWsuvI__"